import React from "react";
import Footer from '../../pages/footer';

export default function Subscription() {

  const currentUsage = 1300; // This could come from an API
  const tiers = [
    { name: 'Developer', base: 0, percent: 0, min: 0, max: 0, maxNodes: 100, maxEnv: 2, maxApi: 20000, maxWebHook: 1000 },
    { name: 'Starter', base: 3500, percent: 1.5, min: 0, max: 100000, maxNodes: 100000, maxEnv: 5, maxApi: 500000, maxWebHook: 20000 },
    { name: 'Business', base: 6000, percent: 1.25, min: 250001, max: 250000, maxNodes: 500000, maxEnv: 10, maxApi: 2000000, maxWebHook: 100000 },
    { name: 'Professional', base: 12000, percent: 1.0, min: 500001, max: 500000, maxNodes: Infinity, maxEnv: 20, maxApi: Infinity, maxWebHook: Infinity },
    /* { name: 'Enterprise', base: 0, percent: 1.0, min: 1000001, max: Infinity, maxNodes: Infinity, maxEnv: 20, maxApi: Infinity, maxWebHook: Infinity }, */
  ];

  const currentTier = tiers.find(
    (tier) => currentUsage >= tier.min && currentUsage <= tier.max
  );


  return <>
    <div className="page-wrapper page-center">
      <div className="page-body">
        <div className="container-xl">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="card">
                <div className="table-responsive">
                  <table className="table table-vcenter table-bordered table-nowrap card-table">
                    <thead>
                      <tr>
                        <td className="w-50">
                          <h2>Automatic tiered pricing based on your usage</h2>
                          <div className="text-muted text-wrap">
                            Our pricing scales with your usage — you&apos;ll automatically move between tiers as your business grows. No caps. No interruptions. Just seamless scaling.
                          </div>
                        </td>
                        {tiers.map((tier) => {
                          const isCurrent = tier.name === currentTier?.name;

                          return (
                            <td className={`text-center ${isCurrent ? 'table-success' : ''}`} key={tier.name}>
                              <div className="text-uppercase text-muted font-weight-medium">
                                {tier.name}
                              </div>
                              <div className="h1 fw-bold my-1">${tier.base}</div>
                              <div className="text-muted small">+ {tier.percent}% of commissions</div>
                              {isCurrent && <div className="fw-bold text-success">Current Tier</div>}
                            </td>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="bg-light">
                        <th colSpan="5" className="subheader">Usage Limits (per month)</th>
                      </tr>
                      <tr>
                        <td>Commissions Generated Monthly</td>
                        {tiers.map((tier) => {
                          return (
                            <td className="text-center" key={tier.name}>
                              {tier.max === Infinity && <>Over ${tier.min.toLocaleString()}</>}
                              {tier.max !== Infinity && <>Up to ${tier.max.toLocaleString()}</>}
                            </td>
                          );
                        })}
                      </tr>
                      <tr>
                        <td>Customer records</td>
                        {tiers.map((tier) => {
                          return (
                            <td className="text-center" key={tier.name}>
                              {tier.maxNodes === Infinity && <>Unlimited</>}
                              {tier.maxNodes !== Infinity && <>{tier.maxNodes.toLocaleString()}</>}
                            </td>
                          );
                        })}
                      </tr>
                      <tr>
                        <td>Environments</td>
                        {tiers.map((tier) => {
                          return (
                            <td className="text-center" key={tier.name}>
                              {tier.maxEnv === Infinity && <>Unlimited</>}
                              {tier.maxEnv !== Infinity && <>{tier.maxEnv.toLocaleString()}</>}
                            </td>
                          );
                        })}
                      </tr>
                      <tr>
                        <td>Webhook messages</td>
                        {tiers.map((tier) => {
                          return (
                            <td className="text-center" key={tier.name}>
                              {tier.maxWebHook === Infinity && <>Unlimited</>}
                              {tier.maxWebHook !== Infinity && <>{tier.maxWebHook.toLocaleString()}</>}
                            </td>
                          );
                        })}
                      </tr>
                      <tr>
                        <td>Api calls</td>
                        {tiers.map((tier) => {
                          return (
                            <td className="text-center" key={tier.name}>
                              {tier.maxApi === Infinity && <>Unlimited</>}
                              {tier.maxApi !== Infinity && <>{tier.maxApi.toLocaleString()}</>}
                            </td>
                          );
                        })}
                      </tr>
                      <tr className="bg-light">
                        <th colSpan="5" className="subheader">Features</th>
                      </tr>
                      <tr>
                        <td>Free hosting and domain name</td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                      </tr>
                      <tr>
                        <td>Admin dashboard to control items</td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                      </tr>
                      <tr className="bg-light">
                        <th colSpan="5" className="subheader">Support</th>
                      </tr>
                      <tr>
                        <td>Email marketing and service</td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-red" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-red" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                      </tr>
                      <tr>
                        <td>24/7 customer support online</td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-red" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                        <td className="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon text-green" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td>
                          <div className="text-muted small mt-2">Applied automatically</div>
                        </td>
                        <td>
                          <a href="#" className="btn btn-green w-100">Current plan</a>
                        </td>
                        <td>
                          <a href="#" className="btn w-100">Choose plan</a>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="card card-md">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col">
                      <h2 className="h3">Enterprise-ready. Reach out for a custom quote.</h2>
                      <p className="m-0 text-muted">Pillars is designed to work great for large enterprises. Take a look at our feature comparison.</p>
                    </div>
                    <div className="col-auto">
                      <a href="#" className="btn">
                        Contact Sales
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </>
}